import React, { Component } from 'react';
import Headline from '../ui/headline';
import Overlay from './overlay';
import { Form } from 'react-redux-form';
import MultiSelect from '../ui/multi-select-basic';
import Checkbox from '../ui/checkbox';
import BodyClassName from 'react-body-classname';
import classNames from 'classnames';

class Admin extends Component {
    componentDidMount() {
        this.props.fetchCurrentlyAssignedTo();
    }

    handleSubmit = e => {
        this.props.reassignSubmitThunk();
    };

    handleCurrentlyAssigned = data => {
        if (data !== null) {
            this.props.fetchCurrentlyAssignedToEvents(data.value);
            this.props.fetchReassignTo(data);
        } else {
            this.props.fetchCurrentlyAssignedToEvents('');
            this.props.fetchReassignTo('');
        }
    };

    render() {
        const totalEvents =
            this.props.assignedData.events.length +
            this.props.assignedData.reports.length +
            this.props.assignedData.tasks.length;
        let reassignedBtnClass = classNames({
            form__submit: true,
            'form__submit--disabled':
                this.props.count === 0 ||
                (this.props.currentlyAssignedToValue === '' ||
                    this.props.currentlyAssignedToValue === null) ||
                (this.props.reassignToValue === '' ||
                    this.props.reassignToValue === null)
        });
        let overlayClass = classNames('form-action-overlay', {
            'is-active': this.props.getReassignSubmitLoading
        });
        return (
            <BodyClassName className="admin">
                <div className="admin">
                    {/* Upon submission overlay shows */}
                    <Overlay overlayClass={overlayClass} />

                    {this.props.successSubmission && (
                        <div className="admin__success">
                            <span onClick={this.props.removeSubmissionBanner}>
                                <svg className="icon icon-close">
                                    <use xlinkHref="#icon-close" />
                                </svg>
                            </span>
                            <p>
                                You have successfully reassigned your event(s).
                            </p>
                        </div>
                    )}

                    <Headline tagValue={1} title={'Event Reassignment'} />

                    <Form
                        model="adminForm"
                        className="admin-form"
                        onSubmit={this.handleSubmit}
                    >
                        <Checkbox
                            model="adminForm.inActive[]"
                            onChange={this.props.fetchCurrentlyAssignedTo}
                            options={[{ name: 'Include inactive', code: '1' }]}
                        />
                        <div className="admin__container">
                            <div className="admin__currently-assigned-to">
                                <MultiSelect
                                    model="adminForm.currentlyAssignedTo"
                                    options={this.props.currentlyAssignedTo}
                                    value={this.props.currentlyAssignedToValue}
                                    onChange={this.handleCurrentlyAssigned}
                                    title="Currently Assigned To"
                                    placeholder="Begin Typing ..."
                                />

                                {/* When a selection from currently assigned to is done it shows it's loading */}
                                {this.props.getAssignedDataLoading && (
                                    <p className="admin__copy">Loading ...</p>
                                )}

                                {/* No data and default to no results value. */}
                                {totalEvents === 0 &&
                                    !this.props.getAssignedDataLoading && (
                                        <p className="admin__copy">
                                            No Results.
                                        </p>
                                    )}

                                {/* This will display the checkboxes from all the events/reports/tasks */}
                                {totalEvents > 0 &&
                                !this.props.getAssignedDataLoading ? (
                                    <div>
                                        <div className="admin__selection-count">
                                            {this.props.count} Items Selected
                                        </div>

                                        {this.props.assignedData.events.length >
                                        0 ? (
                                            <div>
                                                <div className="admin__all">
                                                    <Checkbox
                                                        model="adminForm.allEvents[]"
                                                        onChange={() =>
                                                            this.props.selectAll(
                                                                'events'
                                                            )
                                                        }
                                                        options={[
                                                            {
                                                                name:
                                                                    'All Events',
                                                                code: 'all'
                                                            }
                                                        ]}
                                                    />
                                                </div>

                                                <div className="admin__selectionGroup">
                                                    <Checkbox
                                                        model="adminForm.events[]"
                                                        onChange={
                                                            this.props.counter
                                                        }
                                                        options={
                                                            this.props
                                                                .assignedData
                                                                .events
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        ) : null}

                                        {this.props.assignedData.reports
                                            .length > 0 ? (
                                            <div>
                                                <div className="admin__all">
                                                    <Checkbox
                                                        model="adminForm.allReports[]"
                                                        onChange={() =>
                                                            this.props.selectAll(
                                                                'reports'
                                                            )
                                                        }
                                                        options={[
                                                            {
                                                                name:
                                                                    'All After Actions',
                                                                code: 'all'
                                                            }
                                                        ]}
                                                    />
                                                </div>

                                                <div className="admin__selectionGroup">
                                                    <Checkbox
                                                        model="adminForm.reports[]"
                                                        onChange={
                                                            this.props.counter
                                                        }
                                                        options={
                                                            this.props
                                                                .assignedData
                                                                .reports
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        ) : null}

                                        {this.props.assignedData.tasks.length >
                                        0 ? (
                                            <div>
                                                <div className="admin__all">
                                                    <Checkbox
                                                        model="adminForm.allTasks[]"
                                                        onChange={() =>
                                                            this.props.selectAll(
                                                                'tasks'
                                                            )
                                                        }
                                                        options={[
                                                            {
                                                                name:
                                                                    'All Tasks',
                                                                code: 'all'
                                                            }
                                                        ]}
                                                    />
                                                </div>
                                                <div className="admin__selectionGroup">
                                                    <Checkbox
                                                        model="adminForm.tasks[]"
                                                        onChange={
                                                            this.props.counter
                                                        }
                                                        options={
                                                            this.props
                                                                .assignedData
                                                                .tasks
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null}
                            </div>

                            <div className="admin__reassign-to">
                                <MultiSelect
                                    model="adminForm.reassignTo"
                                    value={this.props.reassignToValue}
                                    options={this.props.getReassignTo}
                                    title="Reassign To"
                                    placeholder="Begin Typing ..."
                                    disabled={
                                        this.props.getReassignTo.length === 0 ||
                                        totalEvents === 0
                                    }
                                />
                            </div>
                        </div>

                        <div className="form__row form__actions ">
                            <button
                                className={reassignedBtnClass}
                                type="submit"
                            >
                                Reassign
                            </button>
                        </div>
                    </Form>
                </div>
            </BodyClassName>
        );
    }
}

export default Admin;



// WEBPACK FOOTER //
// ./src/components/admin/index.js